import type { Theme } from '@emotion/react';
import { stackClasses } from '@mui/material';
import theme from 'providers/theme/theme';
import type { StyleExtend } from 'providers/theme/theme.types';

export const CoverageTableHeaderStackStyle: StyleExtend<Theme> = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 2,
  backgroundColor: theme.palette.customColors.lightBeige,
  p: theme.spacing(1.5, 3),
  border: `1px solid ${theme.palette.customColors.cream}`,
  borderTop: 'none',
  [`&>.${stackClasses.root}>h3:first-of-type`]: {
    fontSize: 18,
    fontWeight: 800,
  },

  [theme.breakpoints.down('md')]: {
    gap: 'unset',

    [`&>.${stackClasses.root}>h3:first-of-type`]: {
      fontSize: 16,
    },
  },
};

export const CoverageTableFirstHeaderStackStyle: StyleExtend<Theme> = {
  borderTop: `1px solid ${theme.palette.customColors.cream}`,
};
